import { render, staticRenderFns } from "./AddIsim.vue?vue&type=template&id=71d44aba&scoped=true"
import script from "./AddIsim.vue?vue&type=script&lang=js"
export * from "./AddIsim.vue?vue&type=script&lang=js"
import style0 from "./AddIsim.vue?vue&type=style&index=0&id=71d44aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d44aba",
  null
  
)

export default component.exports